import {Action, createReducer} from '@ngrx/store';
import {List} from "immutable";
import {produceOn} from "../../common";
import {IFasterqState} from "../../interfaces/fasterq-interfaces";
import {initialFasterqState} from "../state/fasterq.state";
import {
    actionFasterqAddedLine,
    actionFasterqLinesSuccess,
    actionFasterqLoadedAnalytics,
    actionFasterqLoadedLine,
    actionFasterqLoadedLines,
    actionFasterqLoadedQueues, actionFasterqLoadedTerminalLine,
    actionFasterqQueueCalledSaved,
    actionFasterqQueueServiceSaved,
    actionFasterqRemovedLine,
    actionFasterqUpdatedLine
} from "../actions/fasterq.actions";
import {FasterqLineModel} from "../../models/fasterq-line-model";
import {FasterqQueueModel} from "../../models/fasterq-queue-model";
import * as _ from 'lodash';
import {FasterqAnalyticsModel} from "../../models/fasterq-analytics";

const featureReducer = createReducer(
    initialFasterqState,
    produceOn(actionFasterqLinesSuccess, (draft, action) => {
        let lines = List([]);
        action.payload.serverReplay.forEach((line) => {
            lines = lines.push(new FasterqLineModel(line));
        });
        draft.lines = lines;
    }),

    // case EffectActions.EFFECT_UPDATED_FASTERQ_LINE:
    produceOn(actionFasterqUpdatedLine, (draft, action) => {
        const index = draft.lines.findIndex((i_fasterqLineModel: FasterqLineModel) => String(i_fasterqLineModel.lineId) == String(action.payload.data.line_id));
        draft.lines = draft.lines.update(index, (i_fasterqLineModel: FasterqLineModel) => {
            i_fasterqLineModel = i_fasterqLineModel.setKey<FasterqLineModel>(FasterqLineModel, 'name', action.payload.data.name);
            return i_fasterqLineModel.setKey<FasterqLineModel>(FasterqLineModel, 'reminder', action.payload.data.reminder);
        });
    }),

    // case EffectActions.EFFECT_REMOVED_FASTERQ_LINE:
    produceOn(actionFasterqRemovedLine, (draft, action) => {
        const index = draft.lines.findIndex((i_fasterqLineModel: FasterqLineModel) => i_fasterqLineModel.lineId == action.payload.line_id);
        draft.lines = draft.lines.remove(index);
    }),

    // case EffectActions.EFFECT_QUEUE_CALL_SAVED:
    produceOn(actionFasterqQueueCalledSaved, (draft, action) => {
        if (_.isNull(action.payload))
            return draft;
        const index = draft.queues.findIndex((i_fasterqLineModel: FasterqQueueModel) => i_fasterqLineModel.queueId == action.payload.queue_id);
        draft.queues = draft.queues.update(index, (i_fasterqQueueModel: FasterqQueueModel) => {
            // var prev = state.fasterq.queues.get(index).called
            // var curr = i_fasterqQueueModel.called;
            // if (!_.isNull(prev) && _.isNull(curr)){
            //     console.log('oops');
            // }
            delete action.payload.queue;
            return i_fasterqQueueModel.setData<FasterqQueueModel>(FasterqQueueModel, action.payload);
        });
        return draft;
    }),

    // case EffectActions.EFFECT_QUEUE_SERVICE_SAVED:
    produceOn(actionFasterqQueueServiceSaved, (draft, action) => {
        const index = draft.queues.findIndex((i_fasterqLineModel: FasterqQueueModel) => i_fasterqLineModel.queueId == action.payload.queue_id);
        draft.queues = draft.queues.update(index, (i_fasterqQueueModel: FasterqQueueModel) => {
            // var prev = state.fasterq.queues.get(index).serviced
            // var curr = i_fasterqQueueModel.serviced;
            // if (!_.isNull(prev) && _.isNull(curr)){
            //     console.log('oops');
            // }
            return i_fasterqQueueModel.setKey<FasterqQueueModel>(FasterqQueueModel, 'serviced', action.payload.serviced);
        });
        return draft;
    }),

    // case EffectActions.EFFECT_ADDED_FASTERQ_LINE:
    produceOn(actionFasterqAddedLine, (draft, action) => {
        draft.lines = draft.lines.push(new FasterqLineModel(action.payload.serverReplay));
    }),

    // case EffectActions.EFFECT_LOADED_FASTERQ_LINES:
    produceOn(actionFasterqLoadedLines, (draft, action) => {
        draft.lines = action.payload as any;
        return draft;
    }),

    // case EffectActions.EFFECT_LOADED_FASTERQ_LINES:
    produceOn(actionFasterqLoadedTerminalLine, (draft, action) => {
        draft.terminal = action.line;
        return draft;
    }),

    // case EffectActions.EFFECT_LOADED_FASTERQ_LINE:
    produceOn(actionFasterqLoadedLine, (draft, action) => {
        draft.terminal = action.payload as any;
        return draft;
    }),

    // case EffectActions.EFFECT_LOADED_FASTERQ_ANALYTICS:
    produceOn(actionFasterqLoadedAnalytics, (draft, action) => {
        draft.analytics = action.payload as any;
        return draft;
    }),

    // case EffectActions.EFFECT_LOADED_FASTERQ_QUEUES:
    produceOn(actionFasterqLoadedQueues, (draft, action) => {
        let queues = List([]);
        if (!action.payload.serverReplay || !_.isArray(action.payload.serverReplay)) return;
        action.payload.serverReplay.forEach((queue) => {
            queues = queues.push(new FasterqQueueModel(queue));
        });
        draft.queues = queues;
    }),

    produceOn(actionFasterqLoadedAnalytics, (draft, action) => {
        let analytics = List([]);
        if (!action.payload.serverReplay || !_.isArray(action.payload.serverReplay)) return;
        action.payload.serverReplay.forEach((analytic) => {
            analytics = analytics.push(new FasterqAnalyticsModel(analytic));
        });
        draft.analytics = analytics;
    })
);

export function fasterqReducers(state: IFasterqState | undefined, action: Action): IFasterqState {
    return featureReducer(state, action);
}
